// extracted by mini-css-extract-plugin
export default {"createworkflowtab":"MenuTabs_createworkflowtab__cJgzu","selected":"MenuTabs_selected__ofari","createworkflowtabcontents":"MenuTabs_createworkflowtabcontents__GC95C"};